/**
 * This is a seperate file to help with code splitting
 */

export const MONACO_EDITOR_CLASSNAME = "hex-monaco";

export const CALC_MONACO_EDITOR_CLASSNAME = "calc-hex-monaco";
